import script from "./ProfileTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileTab.vue?vue&type=script&setup=true&lang=js"

import "./ProfileTab.vue?vue&type=style&index=0&id=00441b84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00441b84"]])

export default __exports__